export const validateFirstName = (value: string): string | null => {
  if (value.length < 2 || value.length > 30) {
    return 'enterValidFirstName'
  }
  if (!/^[A-Za-z가-힣\s]+$/.test(value)) {
    return 'enterValidFirstName'
  }
  return null
}

export const validateLastName = (value: string): string | null => {
  if (value.length < 2 || value.length > 30) {
    return 'enterValidLastName'
  }
  if (!/^[A-Za-z가-힣\s]+$/.test(value)) {
    return 'enterValidLastName'
  }
  return null
}

export const validateEmail = (value: string): string | null => {
  if (!value || value.trim().length === 0) {
    return 'enterValidEmail'
  }

  if (value.length > 320) {
    return 'enterValidEmail'
  }

  // ww
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  if (!regex.test(value)) {
    return 'enterValidEmail'
  }

  return null
}

export const validatePassword = (value: string): string | null => {
  let passedChecks = 0

  // Check 1: Length between 8-16 characters
  if (value.length >= 8 && value.length <= 16) {
    passedChecks++
  }

  // Check 2: At least one uppercase letter
  if (/[A-Z]/.test(value)) {
    passedChecks++
  }

  // Check 3: At least one lowercase letter
  if (/[a-z]/.test(value)) {
    passedChecks++
  }

  // Check 4: At least one number
  if (/[0-9]/.test(value)) {
    passedChecks++
  }

  // Check 5: At least one special character
  if (/[!@#$%^&*]/.test(value)) {
    passedChecks++
  }

  // Require at least 3 out of 5 criteria to pass
  if (passedChecks < 3) {
    return 'passwordLength8'
  }

  return null
}

/**
 * Validates password strength in real-time for UI feedback
 * Returns boolean flags for each requirement to show visual indicators
 * Requirements: At least 8 characters + 3 out of 4 character types (uppercase, lowercase, number, special)
 */
export const validatePasswordStrength = (
  value: string
): { validLength: boolean; validCharacters: boolean } => {
  // Check if password is at least 8 characters
  const validLength = value.length >= 8

  // Check character type presence
  const hasUpperCase = /[A-Z]/.test(value)
  const hasLowerCase = /[a-z]/.test(value)
  const hasNumbers = /[0-9]/.test(value)
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value)

  // Count how many character types are present (requires at least 3 out of 4)
  const characterTypeCount = [
    hasUpperCase,
    hasLowerCase,
    hasNumbers,
    hasSpecialChar,
  ].filter(Boolean).length

  const validCharacters = characterTypeCount >= 3

  return { validLength, validCharacters }
}

export const validateCompany = (value: string): string | null => {
  // Company is optional - skip validation if empty
  if (!value || value.trim().length === 0) {
    return null
  }

  if (value.length < 2 || value.length > 50) {
    return 'enterValidName'
  }
  if (!/^[A-Za-z가-힣0-9\s]+$/.test(value)) {
    return 'enterValidName'
  }
  return null
}
